export default __webpack_public_path__ + "static/media/cal-list.1396ae2b.png";